import { Box } from "@mui/material";
import LiveVehicleStatusCard from "./LiveVehicleStatusCard";
import TotalVehiclesCard from "./TotalVehiclesCard";
import FleetMetricsCard from "./FleetMetricsCard";
import { useEffect, useState } from "react";
import { getSummaryStats } from "../../Api/FleetOverviewApi";
import { useBaseEntityInfo } from "../../Hooks/usePagesContent";

const StatsSection = ({ globalFilters }) => {
    const [stats, setStats] = useState({});
    const [loading, setLoading] = useState(false);

    const fetchStats = async () => {
        setLoading(true);
        const statsResponse = await getSummaryStats(globalFilters);
        setStats(statsResponse?.response?.data?.stats || {});
        setLoading(false);
    }

    useEffect(() => {
        if (Object.keys(globalFilters).length > 0) {
            fetchStats();
        };
    }, [globalFilters])

    return (
        <Box sx={{ display: 'flex', gap: 2 }}>
            <Box sx={{ width: '75%' }}>
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <Box sx={{ width: '30%', display: 'flex' }}>
                        <TotalVehiclesCard stats={stats} globalFilters={globalFilters} loading={loading} />
                    </Box>
                    <Box sx={{ width: '70%', display: 'flex' }}>
                        <LiveVehicleStatusCard stats={stats} globalFilters={globalFilters} loading={loading} />
                    </Box>
                </Box>
            </Box>
            <Box sx={{ width: '25%', display: 'flex' }}>
                <FleetMetricsCard stats={stats} loading={loading} />
            </Box>
        </Box>
    )
}

export default StatsSection;
